import React from 'react';

export function SearchByCampusInnovation() {
  return <h1>Inovação - Consulta por Campus</h1>;
}
